<div class="w-full md:w-1/2 lg:w-1/3 m-auto rounded-lg border border-gray-500 p-2 mt-2">
  <div class="text-lg font-bold mb-2">Invite Admin (Non Driver)</div>
  <form class="flex flex-col" [formGroup]="formGroup" autocomplete="off" (ngSubmit)="invite()">
    <div class="text-gray-700">LoHi Logistics will send a text invite to this user</div>
    <mat-form-field>
      <mat-label>Phone Number</mat-label>
      <ngx-mat-intl-tel-input
        [preferredCountries]="['us']"
        [enablePlaceholder]="true"
        [enableSearch]="true"
        format="national"
        name="phoneNumber"
        formControlName="phoneNumber"
      ></ngx-mat-intl-tel-input>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Full Legal Name</mat-label>
      <input matInput formControlName="name" autocomplete="off" />
    </mat-form-field>
    <mat-form-field *ngIf="formGroup.get('email').enabled">
      <mat-label>Company Email</mat-label>
      <input matInput formControlName="email" autocomplete="off" />
    </mat-form-field>
    <mat-form-field *ngIf="formGroup.get('password').enabled">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" autocomplete="off" />
    </mat-form-field>
    <button type="submit" mat-raised-button color="primary">Invite Admin</button>
  </form>
</div>
